angular.module('userSettingsMod')

.controller('userEmailCtrl', ['$location', '$scope', 'cnfg', '$templateCache', 'storage', '$timeout', function($location, $scope, cnfg, $templateCache, storage, $timeout) {

	$scope.storage_user = angular.copy(storage.getMainStorage().user);

	$scope.email_form = {};

	if($scope.storage_user){
			$scope.email_form = {
					email: angular.copy($scope.storage_user.username),
			};
	}

	$scope.send = async function() {
		var data = angular.copy($scope.email_form);
		if ($scope.emailForm.$valid) {

			var dataToSend = {
				user_id: $scope.storage_user.user_id,
				username: data.email,
			};

			try {

				let user = await gudhub.updateUser(dataToSend);

				$scope.errMsg = 'Ok!';
				$scope.$digest();

			} catch(error) {

				$scope.errMsg = error.data + ' Please, try again...';

			} finally {

				$timeout(function() {
					$scope.errMsg = "";
				}, 1500);
			}
		}
	};

	$scope.cancel = function(){
		$location.path('/apps');
	};

}]);
